<template>
  <LoadingIcon v-if="isLoading" />
  <CardStatusButton
    v-else
    :class="widgetStyle"
    :data-test-id="`HomeWidgetSmall__${widgetType}`"
    :icon="widgetIcon"
    iconPosition="right"
    :label="name"
    :title="metricValue"
    :type="widgetBorderType"
    @click="handleActionButtonClick"
  />
</template>

<script>
import {
  CardStatusButton,
  LoadingIcon,
} from '@jumpcloud/ui-components';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';

const { widgetNames, widgetTypes } = HomeWidgetConsts;
export default {
  name: 'HomeWidgetSmall',
  components: {
    CardStatusButton,
    LoadingIcon,
  },
  props: {
    actionButtonHandler: {
      type: Function,
      default: () => {},
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    metric: {
      type: Number,
      default: 0,
    },
    widgetBorder: {
      type: String,
      default: '',
    },
    widgetType: {
      required: true,
      type: String,
    },
  },

  computed: {
    metricValue() {
      return !this.hasError ? this.metric.toString() : 'An error occurred.';
    },

    name() {
      return (this.widgetType === widgetTypes.diskEncryption)
        ? widgetNames[widgetTypes.unencryptedDevices]
        : widgetNames[this.widgetType];
    },

    widgetBorderType() {
      if (this.widgetBorder !== '') {
        return this.widgetBorder;
      } if (this.widgetType === widgetTypes.ScheduledUserSuspensions
      || this.widgetType === widgetTypes.ScheduledUserActivations
      || this.widgetType === widgetTypes.newUsers
      || this.widgetType === widgetTypes.userGroupSuggestions) {
        return 'informational';
      } if (this.metric === 0) {
        return 'success';
      }
      return 'warning';
    },

    widgetIcon() {
      if (this.widgetBorderType === 'warning' || this.widgetBorderType === 'error') { return 'error'; }
      if (this.widgetBorderType === 'informational') { return 'info'; }
      return 'checkmarkCircle';
    },

    widgetStyle() {
      const classes = [this.$style.widgetClass];
      if (this.hasError) {
        classes.push(this.$style.errorText);
      }

      return classes;
    },

  },
  methods: {
    handleActionButtonClick() {
      this.actionButtonHandler();
    },
  },
};
</script>

<style module scoped>
.errorText {
  font-style: italic;
}

.widgetClass {
  cursor: pointer;
}

</style>
